import React from "react";
import Header from "./Header";
import Footer from "./Footer";

const PublicLayout = ({ children }) => {
  return (
    <>
      <Header />
      <div className="pt-16 bg-[rgb(244,244,234)]">{children}</div>
      <Footer />
    </>
  );
};

export default PublicLayout;
